import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FindingEventView, FindingStatusResult, SetFindingStatusInput } from '@ametica/shared';
import { api } from './client';
import { SITES_KEY } from './sites';

export const FINDINGS_KEY = ['findings'] as const;
const eventsKey = (id: string) => [...FINDINGS_KEY, id, 'events'] as const;

/** História stavov nálezu — aktér null = systém (matching). */
export function useFindingEvents(id: string, enabled = true) {
  return useQuery({ queryKey: eventsKey(id), queryFn: () => api<FindingEventView[]>(`/findings/${id}/events`), enabled });
}

/**
 * Ručný prechod: ignorovať, akceptovať riziko, znovu otvoriť. 409 = prechod nie je
 * povolený (napr. uzavretý nález) alebo nález medzitým zmenil stav.
 * Po úspechu sa obnovia všetky zoznamy, v ktorých nález môže sedieť (stránky, tabuľka nálezov, prehľad).
 */
export function useSetFindingStatus(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SetFindingStatusInput) =>
      api<FindingStatusResult>(`/findings/${id}/status`, { method: 'POST', body: JSON.stringify(input) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SITES_KEY });
      qc.invalidateQueries({ queryKey: FINDINGS_KEY });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
